import styled from 'styled-components';
var ChartDesktopContainer = styled.div.withConfig({
  displayName: "ChartDesktopContainer",
  componentId: "rbaw8u-0"
})(["display:flex;"]);
export default ChartDesktopContainer;